/**
 * Export a const with the sizes that are going to be used across the APP.
 * There are already some sizes pre-given for TEXT and MARGINS.
 * Using this global sizes for as much as we can will make the UI be evenly proportion in any distance as separation
 */

export const TEXT_SIZE = {
    INPUT_SMALL: 12,
    // tslint:disable-next-line:object-literal-sort-keys
    INPUT_NORMAL: 16,
    LABEL_NORMAL: 14,
    TITLE_SMALL: 18,
    EXTRA_LARGE: 20,
};

const GRID_SIZE = 8;

export const SIZE = {
    QUART: GRID_SIZE * 0.25,
    HALF: GRID_SIZE * 0.5,
    ONE_AND_A_HALF: GRID_SIZE * 1.5,
    ONE: GRID_SIZE * 1,
    TWO: GRID_SIZE * 2,
    // tslint:disable-next-line:object-literal-sort-keys
    THREE: GRID_SIZE * 3,
    FOUR: GRID_SIZE * 4,
    FIVE: GRID_SIZE * 5,
    SIX: GRID_SIZE * 6,
    SEVEN: GRID_SIZE * 7,
    EIGHT: GRID_SIZE * 8,
    NINE: GRID_SIZE * 9,
    TEN: GRID_SIZE * 10,
    ELEVEN: GRID_SIZE * 11,
    TWELVE: GRID_SIZE * 12,
    THIRTEEN: GRID_SIZE * 13,
    FOURTEEN: GRID_SIZE * 14,
    FIFTEEN: GRID_SIZE * 15,
    SIXTEEN: GRID_SIZE * 16,
    SEVENTEEN: GRID_SIZE * 17,
    EIGHTEEN: GRID_SIZE * 18,
    NINETEEN: GRID_SIZE * 19,
    TWENTY: GRID_SIZE * 20,
    TWENTYONE: GRID_SIZE * 21,
    TWENTYTWO: GRID_SIZE * 22,
    TWENTYTHREE: GRID_SIZE * 23,
    TWENTYFOUR: GRID_SIZE * 24,
    TWENTYFIVE: GRID_SIZE * 25,
    TWENTYSIX: GRID_SIZE * 26,
    TWENTY_SEVEN: GRID_SIZE * 27,
    TWENTYEIGHT: GRID_SIZE * 28,
    TWENTYNINE: GRID_SIZE * 29,
    THIRTY: GRID_SIZE * 30,
    THIRTY_TWO: GRID_SIZE * 32,
    THIRTY_THREE: GRID_SIZE * 33,
    THIRTY_FIVE: GRID_SIZE * 35,
    THIRTY_SIX: GRID_SIZE * 36,
    THIRTY_SEVEN: GRID_SIZE * 37,
    FORTY: GRID_SIZE * 40,
    FORTY_TWO: GRID_SIZE * 42,
    FORTY_FIVE: GRID_SIZE * 45,
    FORTYSIX: GRID_SIZE * 46,
    FORTYEIGHT: GRID_SIZE * 48,
    FIFTY: GRID_SIZE * 50,
    FIFTYONE: GRID_SIZE * 51,
    FIFTYTWO: GRID_SIZE * 52,
    FIFTYFOUR: GRID_SIZE * 54,
    FIFTYFIVE: GRID_SIZE * 55,
    FIFTY_SEVEN: GRID_SIZE * 57,
    SIXTY: GRID_SIZE * 60,
    SIXTY_TRHEE: GRID_SIZE * 63,
    SIXTY_FOUR: GRID_SIZE * 64,
    SIXTYEIGHT: GRID_SIZE * 68,
    SEVENTY: GRID_SIZE * 70,
    SEVENTYTHREE: GRID_SIZE * 73,
    SEVENTY_FIVE: GRID_SIZE * 75,
    SEVENTY_SEVEN: GRID_SIZE * 77,
    EIGHTY: GRID_SIZE * 80,
    EIGHTY_TWO: GRID_SIZE * 82,
    EIGHTY_FOUR: GRID_SIZE * 84,
    EIGHTY_FIVE: GRID_SIZE * 85,
    EIGHTY_SIX: GRID_SIZE * 86,
    EIGHTY_SEVEN: GRID_SIZE * 87,
    NINETY: GRID_SIZE * 90,
    NINETY_FIVE: GRID_SIZE * 95,
    HUNDRED: GRID_SIZE * 100,
    HUNDRED_ONE: GRID_SIZE * 101,
    HUNDRED_FOUR: GRID_SIZE * 104,
    HUNDRED_THIRTEEN: GRID_SIZE * 113,
    HUNDRED_SEVENTY_SEVEN: GRID_SIZE * 177
};

export const LAYERS = {
    LAYER_1: 100,
    LAYER_2: 200,
    LAYER_3: 300,
    LAYER_4: 400,
    LAYER_5: 500,
    LAYER_6: 600,
};
